/** FE schedule / selection roles. Legacy API may still send `secondary`. */
export type FeDispatchRole = 'primary' | 'additional'
export type FeDispatchRoleInput = FeDispatchRole | 'secondary' | string | null | undefined

/** Normalize legacy `secondary` → `additional` for writes and UI. */
export function normalizeFeDispatchRole(role: FeDispatchRoleInput): FeDispatchRole {
  if (role === 'primary') return 'primary'
  return 'additional'
}

export function isAdditionalFeRole(role: FeDispatchRoleInput): boolean {
  return role === 'additional' || role === 'secondary'
}

export function isPrimaryFeRole(role: FeDispatchRoleInput): boolean {
  return normalizeFeDispatchRole(role) === 'primary'
}

/** 0-based additional FE index → "2nd FE", "3rd FE", … */
export function additionalFeOrdinalLabel(zeroBasedIndex: number): string {
  const n = zeroBasedIndex + 2
  const mod100 = n % 100
  const mod10 = n % 10
  let suffix = 'th'
  if (mod100 < 11 || mod100 > 13) {
    if (mod10 === 1) suffix = 'st'
    else if (mod10 === 2) suffix = 'nd'
    else if (mod10 === 3) suffix = 'rd'
  }
  return `${n}${suffix} FE`
}

/** Prefer additionalFeUserIds; fall back to legacy backupEngineerIds during API transition. */
export function resolveAdditionalFeUserIds(source: {
  additionalFeUserIds?: number[] | null
  additional_fe_user_ids?: number[] | null
  backupEngineerIds?: number[] | null
  backup_engineer_ids?: number[] | null
}): number[] {
  const raw =
    source.additionalFeUserIds ??
    source.additional_fe_user_ids ??
    source.backupEngineerIds ??
    source.backup_engineer_ids ??
    []
  if (!Array.isArray(raw)) return []
  return [...new Set(raw.map(Number).filter((id) => id > 0))]
}
